import React, { useState, useEffect } from 'react';
import ScrollNav from './ScrollNav';
import SectionHeader from '../SectionHeader/SectionHeader';
import { useParams, useNavigate } from 'react-router-dom';
import config from '../../config';


const getYoutubeEmbedUrl = (url) => {
  const videoIdMatch = url.match(/(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/);
  return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}` : url;
};

const BlogDetail = () => {

  const { id } = useParams(); // Get the blog ID from the URL
  const [blog, setBlog] = useState(null); // used for fetching one blog only for detail view
  const [blogs, setBlogs] = useState([]); // used for the scroll navigation
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await fetch(`${config.apiUrl}/blogs/${id}`);
        const blogData = await response.json();
        setBlog(blogData);
      } catch (error) {
        console.error('Error fetching blog', error);
      }
    };
    fetchBlog();
  }, [id]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(`${config.apiUrl}/blogs`);
        const blogsData = await response.json();
        setBlogs(blogsData);
      } catch (error) {
        console.error('Error fetching blogs', error);
      }
    };
    fetchBlogs();
  }, []);

  const scroll = (direction) => {
    const currentIndex = blogs.findIndex(b => b.id === blog.id);
    let newIndex = currentIndex;

    if (direction === 'back' && currentIndex > 0) {
      newIndex = currentIndex - 1;
    } else if (direction === 'forward' && currentIndex < blogs.length - 1) {
      newIndex = currentIndex + 1;
    }

    if (newIndex !== currentIndex) {
      navigate(`/blog/${blogs[newIndex].id}`);
    }
  };

  const loadListView = () => {
    navigate('/blog'); // Navigate back to the blog list view
  };


  if (!blog) {
    return <div>Loading...</div>;
  }

	return (
		<div className='box-shadow'>
      <SectionHeader name={'Blogs'} />
      <div className='detail-item-container'>
        <div className="title-scrollnav-container">
          <h1 style={{ minHeight: '100px' }}>{blog.title}</h1>
          <ScrollNav scroll={scroll} loadListView={loadListView} />
        </div>
        <hr />

            <p className='justify-right category-large'>{blog.category}</p>
            <img className='detail-image' src={`${blog.photo}-medium.jpg`} alt={blog.title} />
            {blog.content.content.map((block, index) => {
              switch (block.type) {
                case 'paragraph':
                  return <p key={index}>{block.text}</p>;
                case 'subheading':
                  return <h3 key={index}>{block.text}</h3>;
                case 'subsubheading':
                  return <h4 key={index}>{block.text}</h4>;
                case 'unorderedlist':
                  return (
                    <ul key={index}>
                      {block.items.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                      ))}
                    </ul>
                  );
                case 'orderedlist':
                  return (
                    <ol key={index}>
                      {block.items.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                      ))}
                    </ol>
                  );
                case 'image':
                  return <img key={index} src={`/${block.url}`} alt={block.alt} width='300px' />;
                case 'embededvideo':
                  const embedUrl = getYoutubeEmbedUrl(block.url);
                  return (
                    <iframe
                      key={index}
                      width="560"
                      height="315"
                      src={embedUrl}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="Embedded YouTube"
                    />
                  );
                default:
                  return <p key={index}>{block.text}</p>;
              }
            })}
          <div className='justify-right'>
          	<ScrollNav scroll = {scroll} loadListView={loadListView} />
          </div>
          </div>
        </div>

	)
}

export default BlogDetail;